import type { SceneKey } from "../flow/scene-keys";
import { mobileControlsForScene } from "../flow/proto-registry";

function gameHost(): HTMLElement {
  const host = document.querySelector<HTMLElement>("#game");
  if (!host) throw new Error("Missing #game host element.");
  return host;
}

/** DOM dataset markers for debugging / future E2E (Kerning screen-state 패턴). */
export function markActiveScene(scene: SceneKey): void {
  const host = gameHost();
  host.dataset.activeScene = scene;
  host.dataset.mobileControls = mobileControlsForScene(scene);
}

export function markPlayScore(score: number, hits: number): void {
  const host = gameHost();
  host.dataset.playScore = String(score);
  host.dataset.playHits = String(hits);
}

export function markAssetsReady(ready: boolean): void {
  gameHost().dataset.assetsReady = String(ready);
}
